import AuthService from '@/common/services/auth.service';

export const IsSchoolGuard = (to, from, next) => {
  if (AuthService.role() === AuthService.ROLES.SCHOOL) {
    return next();
  }

  return next('404');
};
